import { createI18n } from 'vue-i18n'
import tr from './locales/tr'

export const LOCALE = 'tr-TR'

const i18n = createI18n({
  legacy: false,
  locale: LOCALE,
  messages: { [LOCALE]: tr },
})

export default i18n
export const { t } = i18n.global
